import React from 'react'
import { useSelector } from 'react-redux'
import { ModalContextProvider } from 'plugins/plugins/leases_plugin/javascripts/ModalContext'
import Form from 'components/form'
import Header from '../SignEditHeader'

export default function Edit() {
  const formInstanceId = useSelector((state) => state.global.formInstanceId)

  return (
    <div style={{ height: '100%' }}>
      <Header />
      <div className="questionnaire-request-interstitial-sign-container">
        <div className="questionnaire-request-interstitial-sign-content dome-relative">
          <ModalContextProvider>
            <Form form_id={formInstanceId} viewOnly={false} />
          </ModalContextProvider>
        </div>
      </div>
    </div>
  )
}
